import React from 'react';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Standard } from 'components/Page';
import { defaultSettings } from 'views/Roster/timeline/config';
import { buildReadinessColumn } from 'views/shared/ReadinessColumn';
import { canViewOptimiser } from 'library/optimiser';
import config from './config';

const getConfig = () => {
  if (!canViewOptimiser()) return config;
  return {
    ...config,
    list: {
      ...config.list,
      columns: [...config.list.columns, buildReadinessColumn()]
    }
  };
};

const Users = ({ permissions }) => (
  <Standard
    canAdmin={permissions.CanAdminUsers()
      .hasPermissions()}
    reducer={{
      item: REDUCER_KEY.userAccount,
      list: REDUCER_KEY.peopleData
    }}
    config={getConfig()}
    permissions={permissions}
    defaultSettings={defaultSettings.filters.activity}
    filterSettings={{
      reducerKey: 'userCollectionValues',
      placeholder: 'user details',
      themeName: 'user',
      showClearButton: false
    }}
  />
);

Users.propTypes = {
  permissions: PropTypes.object.isRequired
};

export default Users;
